import { useEffect, useMemo } from 'react';
import { Table, Message } from 'semantic-ui-react';
import { usePagination, useTable, useFilters, useSortBy } from 'react-table';
import styled from 'styled-components';
import TableStylesCompact from './TableStylesCompact';
import PaginationSection from './PaginationSection';
import DefaultColumnFilter from './DefaultColumnFilter';

const CustomTable = styled(Table)`
	margin : 1em 0 .3em 0 !important;
	width : 100%;
`;

const TableWrapper = styled.div`
	width: 100%;
`;

const FilterTH = styled.th`
	text-align : center !important;
	padding : 5px !important;
`;

const HeaderTH = styled.th`
	padding: 10px 5px !important;
`;

const CenterMessage = styled(Message)`
	text-align: center;
`;

function BasicPaginatedTable({ columns, data, show_filters = true, default_page_size, hidden_columns = [] }) {
	const defaultColumn = useMemo(() => ({
		Filter: DefaultColumnFilter,
	}), []);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		prepareRow,
		page,

		canPreviousPage,
		canNextPage,
		pageCount,
		gotoPage,
		nextPage,
		previousPage,
		state : { pageIndex }
	} = useTable(
		{
			columns,
			data,
			defaultColumn,
			initialState : { pageIndex : 0, page_size : 15, hiddenColumns : hidden_columns }
		},
		useFilters,
		useSortBy,
		usePagination
	);

	useEffect(() => {
		// setPageSize(default_page_size || 10);
	}, []);

	return (
		<TableStylesCompact>
			<TableWrapper>
				<CustomTable striped celled {...getTableProps()}>
					<thead>
						{headerGroups.map((headerGroup, i) => (
							<tr {...headerGroup.getHeaderGroupProps} key={`${i}-a`}>
								{headerGroup.headers.map(column => (
									<HeaderTH
										{...column.getHeaderProps({
											...column.getSortByToggleProps(),
											className: column.collapse ? `collapse` : ``
										})}
									>
										{column.render('Header')}
									</HeaderTH>
								))}
							</tr>
						))}

						{show_filters &&
							<>
								{headerGroups.map((headerGroup, i) => (
									<tr {...headerGroup.getHeaderGroupProps} key={`${i}-b`}>
										{headerGroup.headers.map(column => (
											<FilterTH {...column.getHeaderProps()}>
												{column.canFilter ? column.render('Filter') : null}
											</FilterTH>
										))}
									</tr>
								))}
							</>
						}
					</thead>

					{data.length ? (
						<Table.Body {...getTableBodyProps()}>
							{page.map((row, i) => {
								prepareRow(row)

								return (
									<tr {...row.getRowProps()} key={i}>
										{row.cells.map(cell => {
											return (
												<td
													{...cell.getCellProps({
														className: cell.column.collapse ? `collapse` : ``
													})}
												>
													{cell.render('Cell')}
												</td>
											)
										})}
									</tr>
								)
							})}
						</Table.Body>
					) : (
						<Table.Body>
							<tr>
								<td colSpan={headerGroups[0].headers.length}>
									<CenterMessage>No records found</CenterMessage>
								</td>
							</tr>
						</Table.Body>
					)}
				</CustomTable>

				<PaginationSection
					page_count={pageCount}
					page_index={pageIndex}
					can_next_page={canNextPage}
					can_previous_page={canPreviousPage}
					nextPage={nextPage}
					previousPage={previousPage}
					gotoPage={gotoPage}
				/>
			</TableWrapper>
		</TableStylesCompact>
	);
}

export default BasicPaginatedTable;
